import React from 'react';
import { Text } from '@blueprint/ui';
import { HistoryTime, Table, TableHead } from './HistoryTable.styles';
import {
    HistoryTableProps,
    HistoryTableItem,
    HistoryTableHeadings
} from './HistoryTable.types';
import { formatHistoryDate } from './HistoryTable.helpers';

const HistoryTable = ({ data, headings, ...rest }: HistoryTableProps) => {
    return (
        <Table {...rest}>
            <TableHead>
                <tr>
                    {headings.map((item, index) => (
                        <th key={index}>{item}</th>
                    ))}
                </tr>
            </TableHead>
            <tbody>
                {data.map((item) => {
                    return (
                        <tr key={item[0].getTime()}>
                            <td>
                                <HistoryTime dateTime={item[0].toISOString()}>
                                    {formatHistoryDate(item[0])}
                                </HistoryTime>
                            </td>
                            <td>
                                <Text isBold={true}>{item[1]}</Text>
                            </td>
                            <td>
                                <Text isBold={true}>{item[2]}</Text>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default HistoryTable;
export type { HistoryTableItem, HistoryTableHeadings };
